import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { FileDirectoriesQuery, GetDataLakeFileInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const QUERY_FILE_DIRECTORIES = gql`
    query fileDirectories($input: GetDataLakeFileInput!) {
        dataLakeFileDirectories (input: $input) {
            message
            errors {
                code
                message
            }
            result
            directoryHierarchyJson
        }
    }
`;

export const queryFileDirectories = async (
    client: ApolloClient<NormalizedCacheObject>,
    directoryPath?: string
) => {
    const includeChildDirectories = directoryPath != null && directoryPath.length > 0;
    const { data, errors } = await client.query<FileDirectoriesQuery>({
        variables: {
            input: {
                directoryPath,
                searchAllChildDirectories: includeChildDirectories,
            }
        },
        query: QUERY_FILE_DIRECTORIES,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.dataLakeFileDirectories;
}
